import ScanbotSDK from "scanbot-web-sdk/ui";

type BarcodeScannerConfiguration = InstanceType<
  typeof ScanbotSDK.UI.Config.BarcodeScannerConfiguration
>;

export function applySingleScanningUseCase(
  config: BarcodeScannerConfiguration,
) {
  const useCase = new ScanbotSDK.UI.Config.SingleScanningMode();

  useCase.confirmationSheetEnabled = true;
  useCase.sheetColor = "#FFFFFF";

  useCase.barcodeImageVisible = true;

  useCase.barcodeTitle.visible = true;
  useCase.barcodeTitle.color = "#000000";

  useCase.barcodeSubtitle.visible = true;
  useCase.barcodeSubtitle.text = "Escaner";
  useCase.barcodeSubtitle.color = "#000000";

  useCase.cancelButton.text = "Cerrar";
  useCase.cancelButton.foreground.color = "#C8193C";
  useCase.cancelButton.background.fillColor = "#00000000";

  useCase.submitButton.text = "Enviar";
  useCase.submitButton.foreground.color = "#FFFFFF";
  useCase.submitButton.background.fillColor = "#C8193C";

  config.useCase = useCase;
}
